@if (data(); as data) {
    Project <span>'{{data.projectName}}' </span> doesn't belong to program <span> '{{data.programName}}' </span>. Please select the correct program.
}
 